import { BASE64_ENCODED_REGEX, NUMBERS_REGEX } from '../constants/regex';
import { IB2CAddress } from '../models/b2c/addresses';

export const MERCHANT_ID = '379dc8f09a4311e7806bbc764e106cf4';

const getValidatedOGInputsValues = () => {
  const hatOg = window.THD_OG_GLOBAL?.clientToken || '';
  const hatOgTs = window.THD_OG_GLOBAL?.timestamp
    ? String(window.THD_OG_GLOBAL?.timestamp)
    : '';
  const hatOgId = window.THD_OG_GLOBAL?.clientId || '';

  const isHatOg = BASE64_ENCODED_REGEX.test(hatOg);
  const isHatOgTs = NUMBERS_REGEX.test(hatOgTs);

  return {
    hatOgId,
    hatOg: isHatOg ? hatOg : '',
    hatOgTs: isHatOgTs ? hatOgTs : '',
  };
};

export const getOrderGrooveAddressPayload = ({
  name,
  postalDetails,
  primaryPhone,
}: IB2CAddress): string => {
  const { hatOgId, hatOg, hatOgTs } = getValidatedOGInputsValues();
  const updatedValue =
    name && postalDetails && primaryPhone
      ? {
          merchant_id: encodeURIComponent(MERCHANT_ID),
          user: {
            user_id: encodeURIComponent(hatOgId),
            ts: encodeURIComponent(hatOgTs),
            sig: encodeURIComponent(hatOg),
          },
          shipping_address: {
            first_name: encodeURIComponent(name.firstName || ''),
            last_name: encodeURIComponent(name.lastName || ''),
            address: encodeURIComponent(postalDetails.addressLine1 || ''),
            address2: encodeURIComponent(postalDetails.addressLine2 || ''),
            city: encodeURIComponent(postalDetails.city || ''),
            state_province_code: encodeURIComponent(postalDetails.state || ''),
            zip_postal_code: encodeURIComponent(postalDetails.zipCode || ''),
            country_code: encodeURIComponent(postalDetails.country || ''),
            phone: encodeURIComponent(primaryPhone.number || ''),
          },
        }
      : {};

  return `update_request=${JSON.stringify(updatedValue)}`;
};
